import React from 'react';
import './style.scss';
import { t } from 'i18next';

export default function Profile() {
  return <div className="profile__wrap"></div>;
}
